// totalStep="1" (질문 1개)- 1.이름&번호
// totalStep="2" (질문 2개)- 1.임플란트 갯수, 2.이름&번호
// qOptionColor - blue, green, teal

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import ThumbnailVideoPlayer from "../components/ThumbnailVideoPlayer";
import { validateName, validatePhoneNumber } from "../utils/validation";
import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import SelectEvents from "../components/SelectEvents";
import PrivacyContent from "./PrivacyContent";

function RandingStyle18({
  urlCode,
  urlCodeSettingId,
  totalStep,
  changedIMG,
  img1Path,
  img2Path,
  video1Path,
  video1Thumbnail,
  video2Path,
  video2Thumbnail,
  img3Path,
  img4Path,
  img5Path,
  img6Path,
  img7Path,
  formFieldColor,
  adTarget,
  keepBTN,
  postBTN,
  eventDates,
  companyName,
  footerPath,
  articleOption,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  eventsOption,
  treatments,
  privacyMessage,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();

  // 상태 관리.
  const [selectedValue, setSelectedValue] = useState(null); // 선택된 값을 저장할 상태

  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });

  const [selectedOption, setSelectedOption] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
    console.log(option);
  };

  const nextStep = () => {
    if (currentStep < 2) setCurrentStep(currentStep + 1);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  // const handleThumbnailClick = () => {
  //   setShowVideo(true); // 썸네일 클릭 시 비디오 보여주기
  // };

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      // 이벤트 복수 세팅
      selectedValue,
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <div className="form-container">
      {eventsOption && (
        <SelectEvents
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          treatments={treatments}
        />
      )}
      {totalStep == 2 && currentStep === 1 && (
        <div className="step1">
          {img1Path && <img src={img1Path} alt="임플란트 고민중이세요?" />}
          {img2Path && <img src={img1Path} alt="임플란트 고민중이세요?" />}
          {img3Path && <img src={img3Path} alt="임플란트 고민중이세요?" />}
          {img4Path && <img src={img4Path} alt="임플란트 고민중이세요?" />}
          {img5Path && <img src={img5Path} alt="임플란트 고민중이세요?" />}

          <div className="sendBtnBox">
            <img src={keepBTN} alt="계속하기" onClick={nextStep} />
          </div>
        </div>
      )}

      {(totalStep == 1 || currentStep === 2) && (
        <div className="step2">
          {img1Path && <img src={img1Path} alt="임플란트 고민중이세요?" />}
          {img2Path && <img src={img1Path} alt="임플란트 고민중이세요?" />}
          {img3Path && <img src={img3Path} alt="임플란트 고민중이세요?" />}
          {img4Path && <img src={img4Path} alt="임플란트 고민중이세요?" />}
          {img5Path && <img src={img5Path} alt="임플란트 고민중이세요?" />}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          <div className="qBox">
            <form
              className="formBox"
              onSubmit={(e) => {
                e.preventDefault(); // 기본 제출 동작 방지
                handleSubmit(); // 기존 handleSubmit 호출
              }}
            >
              <div
                className={`formField ${
                  formFieldColor === "white" ? "white" : ""
                }`}
              >
                <label htmlFor="name">이름</label>
                <input
                  type="text"
                  id="name"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="이름을 입력해주세요."
                />
              </div>
              <PhoneNumberInput
                phoneNumber={phoneNumber}
                phoneFirstOptions={phoneFirstOptions}
                handlePhoneNumberChange={handlePhoneNumberChange}
                formFieldColor={formFieldColor}
              />
              <PrivacyPolicyAgree
                isAgreed={isAgreed}
                setIsAgreed={setIsAgreed}
                togglePrivacyPolicyModal={togglePrivacyPolicyModal}
                privacyMessage={privacyMessage}
              />
              {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
              {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
              {isPrivacyPolicyModal && (
                <div
                  className="modalOverlay"
                  onClick={togglePrivacyPolicyModal}
                >
                  <div
                    className="privacyPolicyContent"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <PrivacyContent companyName={companyName} />
                  </div>
                </div>
              )}
              <p className="benefitInfo">
                {eventDates && (
                  <>
                    <BenefitPeriod /> <br />
                  </>
                )}
                이벤트 대상자 : {adTarget ? adTarget : "해당 매체 이용자"}
              </p>
              <button
                type="submit"
                className="sendBtnBox"
                disabled={isSubmitting}
              >
                <img src={postBTN} alt="신청하기" />
              </button>
            </form>
          </div>
        </div>
      )}
      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </div>
  );
}

export default RandingStyle18;
